var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-screen',[_c('div',{staticClass:"p-2"},[_vm._v("\n        loading...\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }